







































import Vue from 'vue'
import { SmallRowOfferElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SmallRowOfferEl',
  props: {
    templateItemData: {
      type: Object as () => SmallRowOfferElInterface,
      required: true
    }
  },
  mounted () {
    if (!this.templateItemData.view) {
      this.templateItemData.view = 'left'
    }
  }
})
